<nb-card class="bg-transparent">
  <nb-card-header class="pb-0">
    <div class="row">
      <div class="col-lg-4 col-12 text-start">
        <h4 class="fw-semibold ls-1">Location Barcodes</h4>
      </div>

    <div class="col-lg-8 col-12 text-end d-flex justify-content-end">
        @if(!barcodeService.isReport){
        <div class="col-lg-4 text-end ">
          <button class="animated-button" (click)="printReport()" [nbSpinner]="this.reportService.isPrinting">
            <span class="label text-white">Print</span> <i class="fas fa-print"></i>
          </button>
        </div>
        }
      </div>
    </div>
    @if(!barcodeService.isReport){
    <nb-card class="mt-4 bg-transparent border-0">
      <nb-card-body class="shadow bg-white grid-wrapper">
        <div class="row align-items-center">
          <div class="col-lg-12 col-12">
            <kw-filter-dropdown [filterSettings]="this.dropdownSettings"
              [gridCountDataAndMessage]="gridMessageAndCount"
              (filterResultsChange)="setFilterResults($event)">
            </kw-filter-dropdown>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
    }
  </nb-card-header>

  <nb-card-body [nbSpinner]="this.isLoading">
    <div class="py-3">
    <div class="card card-warehouse" *ngFor="let warehouse of this.barcodeService.selectedWarehouses">
      <div class="card-header card-warehouse-header">
        <div class="row align-items-center">
          <div class="col-lg-8 col-12">
            <h3 class="text-white">{{warehouse.name}}</h3>
          </div>
          <div class="col-lg-4 col-12 text-end barcode-container">            
            <ngx-barcode6 [bc-value]="warehouse.barcode" [bc-display-value]="true"
              [bc-width]="1.5" [bc-height]="20"></ngx-barcode6>
          </div>
        </div>
      </div>
      <div class="card-body p-0" *ngFor="let room of warehouse.rooms">
        <!-- Room 1 -->
        <div class="card-header card-room-header">
          <div class="row align-items-center">
            <div class="col-lg-8 col-12">
              <h3>{{room.name}}</h3>
            </div>
            <div class="col-lg-4 col-12 text-end barcode-container">
               <ngx-barcode6 [bc-value]="room.barcode" [bc-display-value]="true"
              [bc-width]="1.5" [bc-height]="20"></ngx-barcode6>
            </div>
          </div>
        </div>
        <div class="row card-location-row align-items-center" *ngFor="let loc of room.locations">
          <div class="col-lg-8 col-12">
            <h3>{{loc.name}}</h3>
          </div>
          <div class="col-lg-4 col-12 text-end barcode-container">
               <ngx-barcode6 [bc-value]="loc.barcode" [bc-display-value]="true"
              [bc-width]="1.5" [bc-height]="20"></ngx-barcode6>
          </div>
        </div>
      </div>
    </div>
  </div>

    <!-- <nb-card *ngFor="let warehouse of this.barcodeService.selectedWarehouses">
      <nb-card-header>
        <div class="row">
          <div class="col-lg-8 col-12 text-white">
            <h3>{{warehouse.name}}</h3>
          </div>
          <div class="col-lg-4 col-12 text-end">

            <ngx-barcode6 [bc-value]="warehouse.barcode" [bc-display-value]="true" style="height: 10px; width: 40px;"
              [bc-width]="1.5" [bc-height]="20"></ngx-barcode6>
          </div>
          <mat-divider style="width: 100%;"></mat-divider>
        </div>
      </nb-card-header>
      <nb-card-body *ngFor="let room of warehouse.rooms">
        <div class="row ms-3">
          <div class="col-lg-8 col-12">
            <h3>{{room.name}}</h3>
          </div>
          <div class="col-lg-4 col-12 text-end">

            <ngx-barcode6 [bc-value]="room.barcode" [bc-display-value]="true" style="height: 10px; width: 40px;"
              [bc-width]="1.5" [bc-height]="20"></ngx-barcode6>
          </div>
        </div>
        <div class="row ms-5" *ngFor="let loc of room.locations">
          <div class="col-lg-8 col-12">
            <h3>{{loc.name}}</h3>
          </div>
          <div class="col-lg-4 col-12 text-end">

            <ngx-barcode6 [bc-value]="loc.barcode" [bc-display-value]="true" style="height: 10px; width: 40px;"
              [bc-width]="1.5" [bc-height]="20"></ngx-barcode6>
          </div>
          <mat-divider style="width: 100%;"></mat-divider>
        </div>
      </nb-card-body>
    </nb-card> -->
  </nb-card-body>
</nb-card>